var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"graph-panel",class:{ 'graph-panel--legend-right': _vm.rightSide }},[_c('div',{ref:"chart",staticClass:"graph-panel__chart"}),_c('div',{ref:"legend",staticClass:"graph-legend"})])
}
var staticRenderFns = []

export { render, staticRenderFns }